import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BoxVariant } from '#pplx/frontend/aether/primitives/BoxPrimitive/BoxVariant.js';
import { BoxPrimitive } from '#pplx/frontend/aether/primitives/BoxPrimitive/index.js';
import { CommandPanelHeader } from '#pplx/frontend/composer-sdk/components/internal/CommandPanelHeader/index.js';
import { panelScrollHandler } from '#pplx/frontend/composer-sdk/components/internal/panelScroll.js';
import React from 'react';
/**
 * Caret-anchored width/height budget for the inline panel. Matches the values the
 * Lexical typeahead menu previously inlined at the call site.
 */
export const INLINE_PANEL_WIDTH_PX = 280;
export const INLINE_PANEL_HEIGHT_PX = 245;
export const InlinePanel = React.memo(function InlinePanel({ children, isTop = false, viewportCollisionLeftOffsetPx = 0, fitContent = false, onReachEnd, title, subtitle, leadingAccessory, trailingAccessory, }) {
    return (_jsxs(BoxPrimitive, { padding: "xs", rounded: "xl", bg: BoxVariant.raised, onScroll: panelScrollHandler(onReachEnd), className: "shadow-md scrollable-container overflow-y-auto overflow-x-hidden", style: {
            width: INLINE_PANEL_WIDTH_PX,
            minWidth: INLINE_PANEL_WIDTH_PX,
            height: fitContent ? 'fit-content' : undefined,
            maxHeight: fitContent ? 'none' : INLINE_PANEL_HEIGHT_PX,
            ...(isTop && { bottom: '48px', position: 'absolute' }),
            ...(viewportCollisionLeftOffsetPx !== 0 && {
                left: `${viewportCollisionLeftOffsetPx}px`,
                position: 'absolute',
            }),
        }, children: [_jsx(CommandPanelHeader, { title: title, subtitle: subtitle, leadingAccessory: leadingAccessory, trailingAccessory: trailingAccessory }), children] }));
});
//# sourceMappingURL=index.js.map